/*
 * A directory reader hands its entries back in batches (Chrome: 100 at a time)
 * and has to be called until it returns none, so reading one directory is itself
 * a loop — and for a flat folder of thousands of files, the only loop there is.
 * That makes the signal worth honouring here rather than only between
 * directories: without it, aborting a ten-thousand-file folder would wait out
 * every remaining batch of the one directory it lives in.
 *
 * The batch already in flight still resolves; what comes back on an abort is the
 * partial list, which the caller discards.
 */
async function readDirectoryEntries(entry: FileSystemDirectoryEntry, signal?: AbortSignal): Promise<FileSystemEntry[]> {
    const dirReader = entry.createReader();
    const entries: FileSystemEntry[] = [];

    for (;;) {
        if (signal?.aborted === true) {
            return entries;
        }

        const batch = await new Promise<FileSystemEntry[]>((resolve, reject): any => {
            dirReader.readEntries(resolve, reject);
        });

        if (batch.length === 0) {
            return entries;
        }

        entries.push(...batch);
    }
}

// ----------------------------------------------------------------------------

export default readDirectoryEntries;
